var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.singleOrderSchema)?_c('TimeAbsoluteInput',{attrs:{"value":_vm.value,"label":_vm.label},on:{"update:value":function($event){return _vm.$emit('update:value', $event)}}}):_c('TimeReferenceInput',{attrs:{"value":_vm.value},on:{"update:value":function($event){return _vm.$emit('update:value', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }